import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Spin } from "antd";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";

import "./style.scss";

const ChildItem = ({ details, showLines, hideChildItem }) => {
    const [showChildren, setShowChildren] = useState(false)
    const hasChildItem = details?.children?.length > 0

    const handleChildSection = () => {
        setShowChildren(!showChildren)
    }

    return (
        <div className="disclosure-child-section">
            <div className="disclosure-child-section-header" onClick={() => hasChildItem && handleChildSection()}>
                <div className="title-section">
                    {showLines && (
                        <div className="section-line" />
                    )}
                    {details?.title}
                </div>
                {hasChildItem && !hideChildItem && (
                    <div className="collapse-section">
                        {showChildren ? <FaChevronUp /> : <FaChevronDown />}
                    </div>
                )}
            </div>
            {showChildren && !hideChildItem && (
                <div className="disclosure-child-section-body">
                    {hasChildItem && details?.children?.map((childContents) => {
                        return (
                            <ChildItem details={childContents} key={childContents?.value} showLines />
                        )
                    })}
                </div>
            )}
        </div>
    )
}

const ParentItem = ({ details, hideChildItem }) => {
    const [showChildren, setShowChildren] = useState(true)
    const hasChildItem = details?.children?.length > 0
    const showChildItem = hideChildItem && (details?.title === "Policy documents" || details?.title === "Webpage References")

    const handleChildSection = () => {
        setShowChildren(!showChildren)
    }

    return (
        <div className="disclosure-parent-section">
            <div className="disclosure-parent-section-header" onClick={() => handleChildSection()}>
                <div className="title-section">{details?.title} {!showChildItem && <sup>*</sup>}</div>
                {!showChildItem && <div className="collapse-section">
                    {showChildren ? <FaChevronUp /> : <FaChevronDown />}
                </div>}
            </div>
            {showChildren && !showChildItem && (
                <div className="disclosure-parent-section-body">
                    {hasChildItem ? (
                        <>
                            {details?.children?.map((childContents) => {
                                return (
                                    <ChildItem details={childContents} key={childContents?.value} hideChildItem={hideChildItem} />
                                )
                            })}
                        </>
                    ) : (
                        <div className="no-contents">
                            <div className="message">No disclosure types available!</div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

const DisclosuresList = ({ model, isCompanySelected, isFYAvailable, hideChildItem, promptEvaluationFlag }) => {
    const { data: disclosuresData, isLoading: disclosureLoading } = useSelector((state) => state.sourceList)

    const isDisclosuresAvailable = disclosuresData?.rightPane?.length > 0

    return (
        <div className="disclosure-container">
            <div className="container-title-section">
                <div className="title-main">DocSource</div>
                <div className="description">Documents used for research purposes of this query</div>
                {isDisclosuresAvailable && !promptEvaluationFlag && <div className="alert"><sup>*</sup> Year refers to Publication Year</div>}
            </div>
            {disclosureLoading && (
                <div className="card-loader-container">
                    <Spin size="large" />
                </div>
            )}

            <div className="disclosures-list-contents">
                {isDisclosuresAvailable && disclosuresData?.rightPane?.map((disclosure) => {
                    return (
                        <ParentItem details={disclosure} key={disclosure?.value} hideChildItem={hideChildItem} />
                    )
                })}

                {!isDisclosuresAvailable && (
                    <div className="no-contents">
                        {!isCompanySelected ? (
                            <div className="message">Please select any {model}</div>
                        )
                            :
                            (isCompanySelected && !isFYAvailable) ? (
                                <div className="message">{promptEvaluationFlag ? "Please select any fiscal year" : "Please select any publication year"}</div>
                            )
                                :
                                (
                                    <div className="message">No disclosure types available!</div>
                                )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default DisclosuresList; 